import AedesAegypti from '../pages/AedesAegypti/AedesAegypti'
import AedesAegyptiPorEquipeAcs from '../pages/AedesAegypti/PorEquipeAcs'
import AedesAegyptiPorAcs from '../pages/AedesAegypti/PorAcs'

export default [
  {
    path: '/aedes-aegypti',
    component: () =>
      import('@/pages/AedesAegypti/Template.vue'),
    children: [
      {
        path: '/aedes-aegypti',
        component: AedesAegypti,
      },
      {
        path: '/aedes-aegypti/equipe/acs',
        component: AedesAegyptiPorEquipeAcs,
      },
      {
        path: '/aedes-aegypti/acs',
        component: AedesAegyptiPorAcs,
      },
    ],
  },
]
